export const ERROR_COLOR = '#f31c30';
export const WARNING_COLOR = '#f99f4b';
export const SUCCESS_COLOR = '#73dd8e';
export const INFO_COLOR = '#32c0e7';
export const DEFAULT_COLOR = '#414141';
